import { useEffect, useState } from "react"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { Button, Stack, TextField, Tooltip, Typography } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { registerImporter } from "routes/asset-register/plugins/excel-import/controller/register-importer"
import { isSame } from "library/normalized-stringify/index.mjs"
import { useRefresh } from "lib/@hooks/useRefresh"
import { PreviewMappingAlert } from "slot-definitions"
import { PreviewAlert } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function SaveCurrentMapping() {
    const [name, setName] = useState("")
    const [mappings] = useBoundValue("fields", {})
    const [headers] = useBoundValue("headers", [])
    const [existing] = useBoundValue("existingMapping", {})
    const [templateNames] = useBoundValue("templateNames", [])

    const refresh = useRefresh()
    const isSameName = templateNames.some((template) => template.toLowerCase() === name.trim().toLowerCase())
    const same = isSame(existing?.mapping, mappings)

    useEffect(() => {
        PreviewAlert.raise({
            error: { isSameName: !same && isSameName },
            info: { noTemplate: !same && !isSameName },
        })
    }, [same, isSameName])

    PreviewMappingAlert.usePlug(<TemplateAlert />)
    return (
        !same && (
            <Stack spacing={3}>
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    data-cy="excel-import-save-mapping"
                    sx={{ width: 1 }}
                >
                    <TextField
                        error={isSameName}
                        value={name}
                        label="Enter Template Name"
                        onChange={setFromEvent(setName)}
                        fullWidth
                    />
                    <Tooltip
                        title={name?.length < 3 ? "Template name must contain at least 3 characters" : ""}
                        arrow
                        sx={{ textAlign: "right" }}
                    >
                        <span>
                            <Button
                                onClick={save}
                                disabled={name?.length < 3 || isSameName}
                                variant="contained"
                                data-cy="excel-import-save-mapping-btn"
                            >
                                Save
                            </Button>
                        </span>
                    </Tooltip>
                </Stack>
            </Stack>
        )
    )

    async function save() {
        existing.mapping = mappings
        registerImporter(headers.map("name").filter(Boolean), name?.trim(), mappings)
        refresh()
    }
}

function TemplateAlert() {
    const { info = {}, error = {} } = useBoundContext()

    if (info?.same) return null

    let message
    if (error?.isSameName) {
        message = "A template with this name already exists - please provide a different name."
    } else if (info?.noTemplate) {
        message =
            "To speed up future imports of this file type, a template can be saved remembering all of your selected fields - This is optional."
    } else return null
    return <Typography variant="body2">{message}</Typography>
}
